export default {
  VALUE: 'value',
};
